import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box } from '@mui/material';
import { useLoanEditorRunnerContext } from 'app/pages/loanApplication/LoanHeaders/LoanInfoHeader/LoanActionsControls';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';
import TaskActionRunner from 'app/shared/modules/TaskActionRunner';
import TaskInfo from 'app/shared/modules/TaskInfo';
import PropTypes from 'prop-types';

import { getLoanConditionByConditionIdAction } from 'store/loanApplications/actions';

import { taskInfoRowStyles } from './TaskInfoRow.styles';

// Hosts the shared TaskInfo module (DocumentView + FileUploadZone + the Ordered
// checkbox) inline inside the expanded task row instead of a dialog. onClose collapses
// the row — TaskInfo calls it on Cancel and on every success path instead of closing a
// (non-existent) dialog.
const TaskInfoRow = ({ task, conditionId, onClose }) => {
  const dispatch = useDispatch();
  const taskActionRunnerContext = useLoanEditorRunnerContext();

  const onTaskActionRefresh = useCallback(
    () => dispatch(getLoanConditionByConditionIdAction({ loanConditionId: conditionId })),
    [conditionId, dispatch],
  );

  return (
    <Box sx={taskInfoRowStyles}>
      <TaskActionRunner
        runnerContext={taskActionRunnerContext}
        task={task}
        onTaskRefresh={onTaskActionRefresh}
      >
        <TaskInfo
          conditionId={conditionId}
          formName={FormNames.CONDITIONS_TASK_INFO}
          task={task}
          onClose={onClose}
        />
      </TaskActionRunner>
    </Box>
  );
};

TaskInfoRow.propTypes = {
  task: PropTypes.object.isRequired,
  conditionId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default memo(TaskInfoRow);
